import Multiselect from 'vue-multiselect';

import 'vue-multiselect/dist/vue-multiselect.min.css';

export default defineNuxtPlugin(nuxtApp => {
  // Register the component globally
  nuxtApp.vueApp.component('multiselect', Multiselect);
});
